import {
  AltHeader100Semibold,
  Header50Medium,
  Header50Semibold,
  Header100Medium,
  Header100Semibold,
  Header150Light,
  Header150Medium,
  Header150Semibold,
  Header200Light,
  Header200Medium,
  Header200Semibold,
  Header300Light,
  Header300Medium,
  Header300Regular,
  Header300Semibold,
  Header400Light,
  Header400Medium,
  Header400Semibold,
  Header500Regular,
  Text50Medium,
  Text50Regular,
  Text50Semibold,
  Text100Medium,
  Text100MediumHigh,
  Text100Regular,
  Text100RegularHigh,
  Text100Semibold,
  Text100SemiboldHigh,
  Text200Medium,
  Text200MediumHigh,
  Text200Regular,
  Text200RegularHigh,
  Text200Semibold,
  Text200SemiboldHigh,
  Text300Medium,
  Text300MediumHigh,
  Text300Regular,
  Text300RegularHigh,
  Text300Semibold,
  Text300SemiboldHigh,
  Text400Medium,
  Text400MediumHigh,
  Text400Regular,
  Text400RegularHigh,
  Text400Semibold,
  Text400SemiboldHigh,
  Text500Medium,
  Text500MediumHigh,
  Text500Regular,
  Text500RegularHigh,
  Text500Semibold,
  Text500SemiboldHigh,
  Text600Medium,
  Text600MediumHigh,
  Text600Regular,
  Text600RegularHigh,
  Text600Semibold,
  Text600SemiboldHigh,
  TextBody15m,
} from './Typography';

export const Typography = {
  AltHeader100Semibold,
  Header50Medium,
  Header50Semibold,
  Header100Medium,
  Header100Semibold,
  Header150Medium,
  Header150Semibold,
  Header150Light,
  Header200Light,
  Header200Medium,
  Header200Semibold,
  Header300Medium,
  Header300Light,
  Header300Regular,
  Header300Semibold,
  Header400Light,
  Header400Medium,
  Header400Semibold,
  Header500Regular,
  Text50Medium,
  Text50Regular,
  Text50Semibold,
  Text100Medium,
  Text100MediumHigh,
  Text100Regular,
  Text100RegularHigh,
  Text100Semibold,
  Text100SemiboldHigh,
  Text200Medium,
  Text200MediumHigh,
  Text200Regular,
  Text200RegularHigh,
  Text200Semibold,
  Text200SemiboldHigh,
  Text300Medium,
  Text300MediumHigh,
  Text300Regular,
  Text300RegularHigh,
  Text300Semibold,
  Text300SemiboldHigh,
  Text400Medium,
  Text400MediumHigh,
  Text400Regular,
  Text400RegularHigh,
  Text400Semibold,
  Text400SemiboldHigh,
  Text500Medium,
  Text500MediumHigh,
  Text500Regular,
  Text500RegularHigh,
  Text500Semibold,
  Text500SemiboldHigh,
  Text600Medium,
  Text600MediumHigh,
  Text600Regular,
  Text600RegularHigh,
  Text600Semibold,
  Text600SemiboldHigh,
  TextBody15m,
};
